function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .az {\n                fill: #fff;\n                opacity: 0;\n            }\n\n            .by {\n                fill: #ea0029;\n            }\n\n            .cx {\n                fill: none;\n                stroke: #ea0029;\n                stroke-width: 2px;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-25.5 -594.862)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "az",
  width: 27.3,
  height: 27.3,
  transform: "translate(25.5 595)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.196 591.625)"
}, /*#__PURE__*/React.createElement("path", {
  className: "by",
  d: "M16.817,18.3h0a3.327,3.327,0,0,0,3.317-3.317V6.692a3.327,3.327,0,0,0-3.317-3.317h0A3.327,3.327,0,0,0,13.5,6.692v8.293A3.327,3.327,0,0,0,16.817,18.3Z",
  transform: "translate(-0.85)"
}), /*#__PURE__*/React.createElement("path", {
  className: "by",
  d: "M20.942,13.5a.728.728,0,0,0-.726.726V17.8a4.25,4.25,0,1,1-8.5,0V14.226a.726.726,0,1,0-1.451,0V17.8a5.708,5.708,0,0,0,4.976,5.654v2.69H13.375a.726.726,0,1,0,0,1.451h5.183a.726.726,0,1,0,0-1.451H16.692v-2.69A5.708,5.708,0,0,0,21.668,17.8V14.226A.728.728,0,0,0,20.942,13.5Z",
  transform: "translate(0 -2.662)"
})), /*#__PURE__*/React.createElement("line", {
  className: "cx",
  x1: 17.231,
  y2: 20.78,
  transform: "translate(30.269 595.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.733-.059l12.882-.06L16.149,1.951,5.487,1.983Z",
  transform: "translate(30.641 614.257) rotate(-50)"
}));

function SvgMutedMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.3,
    height: 27.438,
    viewBox: "0 0 27.3 27.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedMic);
export default __webpack_public_path__ + "static/media/muted_mic.a6293a09.svg";
export { ForwardRef as ReactComponent };